import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Spedizione} from '../../../_models/Spedizione';
import {Subscription} from 'rxjs';
import {SaveMessage} from '../../../_helpers/save-message';
import {LocalService} from '../../../_services/local.service';
import {SpedizioniService} from '../../../_services/spedizioni.service';
import {InfiniteScrollCustomEvent, ModalController} from '@ionic/angular';
import {OrganizzazioniService} from '../../../_services/organizzazioni.service';
import {Organizzazione} from '../../../_models/Organizzazione';
import {SearchResult} from '../../../_models/SearchResult';
import {DocumentoMagazzinoCreateComponent} from '../documento-magazzino-create/documento-magazzino-create.component';
import {Router} from '@angular/router';
import {SelectDateRangeComponent} from "../../select/select-date-range/select-date-range.component";

@Component({
  selector: 'app-documento-magazzino-list',
  templateUrl: './documento-magazzino-list.component.html',
  styleUrls: ['./documento-magazzino-list.component.scss'],
  standalone: false
})
export class DocumentoMagazzinoListComponent implements OnInit, OnDestroy {
  @Input() contesto = 4;
  @Input() codCliFor = -1;
  @Input() rifDoc = '';
  @Input() stato = -1;
  @Input() idDocumento: number;
  @Input() idRiga: number;
  @Input() idRigaLavorazione: number;
  spedizioni: Spedizione[] = [];
  search = '';
  page = 0;
  count = 20;
  totalCount = 0;
  startDate = new Date(2000, 0, 1, 0, 0, 0).toISOString();
  endDate = new Date(2099, 11, 31, 1, 0, 0).toISOString();
  sortKey = 'dataDocumento';
  sortDirection = false;
  loading = false;
  loadMore = false;
  subscription: Subscription;

  constructor(
    private router: Router,
    private saveMessage: SaveMessage,
    private localService: LocalService,
    private spedizioniService: SpedizioniService,
    private modalCtrl: ModalController,
    private organizzazioniService: OrganizzazioniService) { }

  ngOnInit() {
    this.subscription = this.localService.searchText.subscribe((_value: string) => {
      this.search = _value;
      this.getSpedizioni(false);
    });
    this.subscription.add(this.organizzazioniService.currentOrganizzazioneSubject
      .subscribe((_org: Organizzazione) => this.getSpedizioni(false)));
    this.subscription.add(this.spedizioniService.lastSpedizioneCreated.subscribe((_spedizione: Spedizione) => {
      if (_spedizione == null || _spedizione.contesto !== this.contesto) {
        return;
      }
      this.spedizioni.unshift(_spedizione);
    }));
    this.subscription.add(this.spedizioniService.lastSpedizioneUpdated.subscribe((_spedizione: Spedizione) => {
      if (_spedizione == null || _spedizione.contesto !== this.contesto) {
        return;
      }
      this.spedizioni.forEach(spedizione => {
        if (spedizione.idSpedizione === _spedizione.idSpedizione) {
          spedizione.stato = _spedizione.stato;
          spedizione.idEvento = _spedizione.idEvento;
          spedizione.dataUnixRegistrazione = _spedizione.dataUnixRegistrazione;
        }
      });
    }));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  infiniteScrollSpedizioni(event) {
    this.getSpedizioni(true)
      .then(() => (event as InfiniteScrollCustomEvent).target.complete());
  }

  getSpedizioni(add = false) {
    this.loading = true;
    this.loadMore = true;
    if (!add) {
      this.spedizioni = [];
      this.page = 0;
    } else {
      this.page += 1;
    }
    this.loading = true;
    return this.spedizioniService
      .getSpedizioni(this.organizzazioniService.organizzazioneId,
        this.search, this.page, this.count, this.sortKey, false, this.contesto,
        this.codCliFor, this.rifDoc, this.stato, new Date(this.startDate), new Date(this.endDate))
      .then((_result: SearchResult<Spedizione>) => {
        this.totalCount = _result.totalCount;
        if (_result.totalCount === 0) {
          this.loadMore = false;
          return false;
        }
        if (!add) {
          this.spedizioni = _result.result;
        } else {
          _result.result.forEach((spe: Spedizione) => this.spedizioni.push(spe));
        }
        if (_result.totalCount <= this.spedizioni.length) {
          this.loadMore = false;
        }
      })
      .catch((_err) => this.saveMessage.messageError("Ci sono problemi con il caricamento delle spedizioni."))
      .finally(() => this.loading = false);
  }

  sort(key: string) {
    if (this.sortKey === key) {
      this.sortDirection = !this.sortDirection;
    }
    this.sortKey = key;
    this.getSpedizioni(false);
  }

  selectSpedizione = (spedizione: Spedizione) => {
    this.router.navigate(['/movimenti/spedizione/', spedizione.idSpedizione]);
  };

  async openModal() {
    const modal = await this.modalCtrl.create({
      component: DocumentoMagazzinoCreateComponent,
      componentProps: {
        contesto: this.contesto, idAnagrafica: this.codCliFor, rifEsterno: this.rifDoc,
        idDocumento: this.idDocumento, idRiga: this.idRiga, idRigaLavorazione: this.idRigaLavorazione
      },
      backdropDismiss: false,
      cssClass: 'custom-modal'
    });
    await modal.present();
    const {role} = await modal.onWillDismiss();
    if (role === 'confirm') {}
  }

  async openDateModal() {
    const modal = await this.modalCtrl.create({
      component: SelectDateRangeComponent,
      componentProps: {
        startDate: this.startDate, endDate: this.endDate
      }
    });
    await modal.present();
    const {data, role} = await modal.onWillDismiss();
    if (role === 'confirm') {
      this.startDate = data.startDate;
      this.endDate = data.endDate;
      await this.getSpedizioni(false);
    }
  }
}
